import {
  airport, private_office, virtual_office, desk,
// @ts-ignore
} from '../../../../assets';

export const cities = [
  [
    { name: 'Miami', url: 'united-states/florida/miami' },
    { name: 'New York City', url: 'united-states/new-york/new-york-city' },
    { name: 'Austin', url: 'united-states/texas/austin' },
    { name: 'Los Angeles', url: 'united-states/california/los-angeles' },
    { name: 'Atlanta', url: 'united-states/georgia/atlanta' },
    { name: 'Houston', url: 'united-states/texas/houston' },
  ],
  [
    { name: 'Hong Kong', url: 'hong-kong/hong-kong' },
    { name: 'Singapore', url: 'singapore/singapore' },
    { name: 'Melbourne', url: 'australia/melbourne' },
    { name: 'Sydney', url: 'australia/sydney' },
  ],
  [
    { name: 'Berlin', url: 'germany/berlin' },
    { name: 'Paris', url: 'france/paris' },
    { name: 'Frankfurt', url: 'germany/frankfurt' },
    { name: 'Warsaw', url: 'poland/warsaw' },
    { name: 'Barcelona', url: 'spain/barcelona' },
    { name: 'Madrid', url: 'spain/madrid' },
    { name: 'Zug', url: 'switzerland/zug' },
    { name: 'Geneva', url: 'switzerland/geneva' },
    { name: 'Amsterdam', url: 'netherlands/amsterdam' },
    { name: 'Brussels', url: 'belgium/brussels' },
    { name: 'Hamburg', url: 'germany/hamburg' },
    { name: 'Munich', url: 'germany/munich' },
  ],
  [
    { name: 'London', url: 'united-kingdom/london' },
    { name: 'Reading', url: 'united-kingdom/reading' },
    { name: 'Manchester', url: 'united-kingdom/manchester' },
    { name: 'Birmingham', url: 'united-kingdom/birmingham' },
    { name: 'Bristol', url: 'united-kingdom/bristol' },
    { name: 'Leeds', url: 'united-kingdom/leeds' },
  ],
];

export const workspaceTypes = [
  {
    href: 'private_offices',
    img: private_office,
    alt: 'private_office',
    heading: 'Private Office',
    description: 'Private furnished space',
  },
  {
    href: 'virtual_offices',
    img: virtual_office,
    alt: 'virtual_office',
    heading: 'Virtual Office',
    description: 'Virtual Office',
  },
  {
    href: 'desks',
    img: desk,
    alt: 'coworking_desk',
    heading: 'Coworking Desk',
    description: 'Desk in a shared coworking space',
  },
  {
    href: 'lounge',
    img: airport,
    alt: 'airport_lounge',
    heading: 'Airport Lounge',
    description: 'Airport Lounge',
  },
];
